import { Formio } from "@formio/js"
import Modal from "bootstrap/js/dist/modal"
import moment from 'moment'
import { allData } from "../app"
import {
    createAudioFile,
    removeAudioFile,
    updateAudioFile,
} from "../server/advayta"
import { addItemToFirebase, removeItemFromFirebase, updateItemInFirebase } from "../server/firebase"
import { getTagifyValues } from "./bookForm"
import FileComponent from "./FileComponent"
import { closeRightPanel, openRightPanel } from "./panels"
import { addRowInTable, deleteRow, updateRowInTable } from "./tabulatorControl"
import { createSelectTagify } from "./tagifySelectControl"
import { showErrorToast, showOkToast } from "./toastControl"
import { showSpinnerOverlay, hideSpinnerOverlay } from './spinner.js'

let form = null
const audioForm = document.getElementById('audioForm')
const fields = [
    {
        type: 'textfield',
        key: 'audioCreatedAt',
        label: 'Дата создания',
        input: true,
    },
    {
        type: 'textfield',
        key: 'audioUpdatedAt',
        label: 'Дата обновления',
        input: true
    },
    {
        type: 'textfield',
        key: 'audioTitle',
        label: 'Название',
        input: true,
        validate: {
            required: true
        }
    },
    {
        type: 'filefield',
        key: 'audioFile',
        label: 'Аудиофайл',
        input: true,
        properties: {
            accept: '.mp3',
            folder: 'firebase/audio',
            isRequired: true
        },
        validate: {
            required: true
        }
    },
    {
        type: 'textfield',
        key: 'audioType',
        label: 'Тип',
        input: true,
        properties: {
            listName: 'audioType',
            fieldName: 'audioType',
            props: ['key', 'value'],
            isSingle: true,
            isRequired: true
        },
        validate: {
            required: true
        }
    },
    {
        type: 'textfield',
        key: 'audioSinger',
        label: 'Исполнитель',
        input: true,
        properties: {
            listName: 'audioSinger',
            fieldName: 'audioSinger',
            props: ['key', 'value'],
            isSingle: true
        }
    },
    {
        type: 'textfield',
        key: 'audioTags',
        label: 'Теги',
        input: true,
        properties: {
            listName: 'audioTags',
            fieldName: 'audioTags',
            props: ['key', 'value', 'color', 'bgColor'],
            isSingle: false,
            isPainted: true
        }
    },
    {
        type: 'textfield',
        key: 'audioDuration',
        label: 'Длительность',
        input: true,
        placeholder: "ЧЧ:ММ:СС",
        inputMask: "99:99:99",
        validate: {
            pattern: "^[0-9]{2}:[0-5][0-9]:[0-5][0-9]$",
            customMessage: "Введите длительность в формате ЧЧ:ММ:СС."
        },
    },
    {
        type: 'textfield',
        key: 'audioDescription',
        label: 'Описание',
        input: true,
    },
    {
        type: 'textfield',
        key: 'audioComment',
        label: 'Комментарий',
        input: true
    },
    {
        type: 'checkbox',
        key: 'paid',
        label: 'Платное',
        input: true
    },
]

export async function initAudioForm() {
    Formio.Components.addComponent('filefield', FileComponent)
    form = await Formio.createForm(audioForm, { components: fields })

    for (let component of form.components) {
        if (!component.component.properties?.listName) continue

        const list = component.component.properties.listName in allData ? Object.values(allData[component.component.properties.listName]) : []
        component.component.properties.tagify = createSelectTagify(list, {
            ...component.component.properties,
            elementId: `${component.component.id}-${component.component.path}`
        })
        component.component.properties.tagify.on('change', e => component.setValue(e.detail.value))
    }
}

export async function showEditAudioForm(row) {
    await openRightPanel()

    if (row.audioDuration && typeof row.audioDuration === 'number') {
        row.audioDuration = secondsToHMS(row.audioDuration)
    }

    await form.setSubmission({ data: row })
    for (let component of form.components) {
        const props = component.component.properties
        const path = component.component.path

        if (!props?.listName || !row[path]) continue

        const tags = Array.isArray(row[path]) ? row[path] : [row[path]]

        if (tags) {
            props.tagify.removeAllTags()
            props.tagify.addTags(tags)
        }
    }
}

export async function saveAudio() {
    if (!form.checkValidity(form.data, true)) return
    showSpinnerOverlay()
    // Обработка файлов для удаления
    try {
        await FileComponent.processAllFilesToDelete()
    } catch (error) {
        console.error('Ошибка при обработке файлов для удаления:', error)
        hideSpinnerOverlay()
        return false
    }

    const listFields = fields.filter(e => e?.properties?.listName)
    for (let field of listFields) {
        if (!form[field.key]) continue
        form[field.key] = ''
    }

    if (form.data.audioDuration && typeof form.data.audioDuration === 'string' && form.data.audioDuration.indexOf(':') > -1) {
        form.data.audioDuration = HMSToSeconds(form.data.audioDuration)
    }

    const firebaseData = { ...form.data, ...getTagifyValues(form.components, true) }
    const tabulatorRowData = { ...form.data, ...getTagifyValues(form.components) }

    if (form.data.key) {
        const response = await updateAudioFile(tabulatorRowData)

        if (response) {
            const createdAt = moment(response.createdAt).format('YYYY-MM-DD')
            const updatedAt = moment(response.updatedAt).format('YYYY-MM-DD')
            form.getComponent('audioCreatedAt').setValue(createdAt)
            form.getComponent('audioUpdatedAt').setValue(updatedAt)
            firebaseData.audioCreatedAt = tabulatorRowData.audioCreatedAt = createdAt
            firebaseData.audioUpdatedAt = tabulatorRowData.audioUpdatedAt = updatedAt

            if (response?.url) {
                firebaseData.audioFile = tabulatorRowData.audioFile = response.url
                form.getComponent('audioFile').setValue(response.url)
            }
        }

        await updateItemInFirebase(firebaseData, 'audios')
        hideSpinnerOverlay()
        updateRowInTable(form.data.key, tabulatorRowData)
        closeRightPanel()
        return
    }

    const key = await addItemToFirebase(firebaseData, 'audios')
    const response = await createAudioFile({ ...tabulatorRowData, key })

    const createdAt = moment(response.createdAt).format('YYYY-MM-DD')
    const updatedAt = moment(response.updatedAt).format('YYYY-MM-DD')
    form.getComponent('audioCreatedAt').setValue(createdAt)
    form.getComponent('audioUpdatedAt').setValue(updatedAt)
    firebaseData.audioCreatedAt = tabulatorRowData.audioCreatedAt = createdAt
    firebaseData.audioUpdatedAt = tabulatorRowData.audioUpdatedAt = updatedAt
    firebaseData.key = key

    updateItemInFirebase(firebaseData, 'audios')

    hideSpinnerOverlay()
    addRowInTable({ key, ...tabulatorRowData })
    closeRightPanel()
    showOkToast('Запись успешно создана')
}

/** spinner overlay controlled by showSpinnerOverlay/hideSpinnerOverlay (see uiControl/spinner.js) */

export async function deleteAudio() {
    const modal = new Modal(document.getElementById('confirmDeleteModalRec'))
    const modalBodyEl = document.querySelector('#confirmDeleteModalRec .modal-body p')
    const title = 'Удалить аудио'
    const addTitle = 'Это приведет к удалению всех файлов связанных с аудио'
    modalBodyEl.innerHTML = `
              <figure class="text-center">
              <blockquote class="blockquote">
                <p>${title} "${form.data.audioTitle}"? <br/> ${addTitle}</p>
              </blockquote>
            </figure>
            `
    const delBtnModal = document.getElementById('confirmDeleteBtnRec')
    modal.show()
    delBtnModal.onclick = async () => {
        try {
            const spinnerEl = delBtnModal.querySelector('span.spinner-border')
            spinnerEl.classList.remove('d-none')
            delBtnModal.setAttribute('disabled', '')

            // document.querySelectorAll('.upload-file-btn').forEach(el => {
            //     const input = el.parentNode.querySelector('input[type="text"]');
            //     if(input && input.value) {
            //         deleteByPath(input.value)
            //     }
            // })

            const result = await removeItemFromFirebase(form.data.key, 'audios')
            removeAudioFile(form.data.key)
            deleteRow(form.data.key)
            closeRightPanel()
            modal.hide()
            spinnerEl.classList.add('d-none')
            delBtnModal.removeAttribute('disabled')
            showOkToast('Аудио успешно удалено')
            console.log(`${result}`)
        } catch (error) {
            console.log(error)
            showErrorToast('Не удалось удалить книгу')
        }
    }
}

export function HMSToSeconds(hms) {
    if (typeof hms === 'number') {
        return hms
    }
    const parts = hms.split(':')
    if (parts.length !== 3) return 0

    const hours = parseInt(parts[0], 10) || 0
    const minutes = parseInt(parts[1], 10) || 0
    const seconds = parseInt(parts[2], 10) || 0

    return hours * 3600 + minutes * 60 + seconds
}

export function secondsToHMS(seconds) {
    seconds = Number(seconds)

    const hours = Math.floor(seconds / 3600)
    const minutes = Math.floor((seconds % 3600) / 60)
    const secs = Math.floor(seconds % 60)

    const pad = (num) => num.toString().padStart(2, '0')

    return `${pad(hours)}:${pad(minutes)}:${pad(secs)}`
}